module.exports = __webpack_public_path__ + "img/map.7ed36c0c.png";